import React from "react";
import propTypes from "prop-types";

import { useHistory, useLocation } from "react-router-dom";

import camelCase from "lodash/camelCase";
import snakeCase from "lodash/snakeCase";

import Navbar from "react-bootstrap/cjs/Navbar";
import Nav from "react-bootstrap/cjs/Nav";
import NavDropdown from "react-bootstrap/cjs/NavDropdown";
import NavDropdownItem from "../components/NavDropdownItem/NavDropdownItem";
import NavbarLink from "../components/NavbarLink/NavbarLink";
import Button from "react-bootstrap/cjs/Button";
import ButtonToolbar from "react-bootstrap/cjs/ButtonToolbar";
import ButtonGroup from "react-bootstrap/cjs/ButtonGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";

import helpPagination from "../data/helpPagination";

const createPageRoute = (page, includeBase = false) => {
  if (Array.isArray(page.subpages)) {
    const subpageRoutes = [
      ...page.subpages
        .map((subpage) => createPageRoute(subpage, true))
        .flat()
        .map((route) => `${snakeCase(page.title)}/${route}`),
    ];
    if (includeBase) return [`${snakeCase(page.title)}`, ...subpageRoutes];
    return subpageRoutes;
  }
  return [`${snakeCase(page.title)}`];
};

const pathMap = helpPagination.reduce((acc, cur) => {
  const pageRoutes = createPageRoute(cur);
  return [...acc, ...pageRoutes.map((route) => `/help/${route}`)];
}, []);

const HelpNavigation = ({ pagination }) => {
  const history = useHistory();
  const location = useLocation();

  const currentPage = pathMap.indexOf(location.pathname);

  const nextPage = () => {
    if (currentPage > -1) {
      if (currentPage === pathMap.length - 1) {
        history.push(pathMap[0]);
      } else {
        history.push(pathMap[currentPage + 1]);
      }
    }
  };

  const prevPage = () => {
    if (currentPage > -1) {
      if (currentPage === 0) {
        history.push(pathMap[pathMap.length - 1]);
      } else {
        history.push(pathMap[currentPage - 1]);
      }
    }
  };

  return (
    <Navbar bg={"light"} variant={"light"}>
      <Nav className={"mr-auto"}>
        {pagination.map((page, p) =>
          page.subpages ? (
            <NavDropdown id={camelCase(page.title)} title={page.title} key={p}>
              {page.subpages.map((subpage, s) => (
                <React.Fragment key={`${p}.${s}`}>
                  <NavDropdownItem
                    exact
                    to={`/help/${snakeCase(page.title)}/${snakeCase(subpage.title)}`}
                  >
                    {`${p + 1}.${s + 1} ${subpage.title}`}
                  </NavDropdownItem>
                  {subpage.subpages
                    ? subpage.subpages.map((subsubpage, ss) => (
                        <NavDropdownItem
                          exact
                          to={`/help/${snakeCase(page.title)}/${snakeCase(
                            subpage.title
                          )}/${snakeCase(subsubpage.title)}`}
                          key={`${p}.${s}.${ss}`}
                        >
                          {`${p + 1}.${s + 1}.${ss + 1} ${subsubpage.title}`}
                        </NavDropdownItem>
                      ))
                    : null}
                </React.Fragment>
              ))}
            </NavDropdown>
          ) : (
            <NavbarLink exact to={`/help/${snakeCase(page.title)}`} key={p}>
              {page.title}
            </NavbarLink>
          )
        )}
      </Nav>
      <ButtonToolbar>
        <Button variant={"secondary"} onClick={window.print}>
          Print
        </Button>
        <ButtonGroup className={"ml-2"}>
          <Button onClick={prevPage}>
            <FontAwesomeIcon icon={faChevronCircleLeft} className={"mr-2"} />
            Prev
          </Button>
          <Button onClick={nextPage}>
            Next
            <FontAwesomeIcon icon={faChevronCircleRight} className={"ml-2"} />
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    </Navbar>
  );
};

HelpNavigation.propTypes = {
  pagination: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string.isRequired,
      subpages: propTypes.arrayOf(
        propTypes.shape({
          title: propTypes.string.isRequired,
          subpages: propTypes.arrayOf(
            propTypes.shape({
              title: propTypes.string,
            })
          ),
        })
      ),
    })
  ),
};

export default HelpNavigation;
